import { render, staticRenderFns } from "./static_position_picker.vue?vue&type=template&id=0f6673ae"
import script from "./static_position_picker.vue?vue&type=script&lang=js"
export * from "./static_position_picker.vue?vue&type=script&lang=js"
import style0 from "./static_position_picker.vue?vue&type=style&index=0&id=0f6673ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports